import React from "react";
import { Link } from "react-router-dom";
import { Scale } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MentionsLegales = () => {
  return (
    <div className="font-sans min-h-screen bg-gray-50">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-black to-flowkraft-primary text-white py-20">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center mb-8">
            <Scale className="w-16 h-16 text-flowkraft-secondary" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6">
            Mentions Légales
          </h1>
          <p className="text-xl text-center text-gray-200 max-w-3xl mx-auto">
            Informations légales concernant FlowKraft Agency
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Éditeur du site */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              1. Éditeur du site
            </h2>
            <div className="text-gray-700 space-y-2">
              <p>
                <strong>Raison sociale :</strong> FlowKraft Agency
              </p>
              <p>
                <strong>Forme juridique :</strong> Micro-entreprise
              </p>
              <p>
                <strong>Adresse :</strong> Toulouse, France
              </p>
              <p>
                <strong>Email :</strong>{" "}
                <a
                  href="mailto:info@flowkraftagency.com"
                  className="text-flowkraft-primary hover:underline"
                >
                  info@flowkraftagency.com
                </a>
              </p>
              <p>
                <strong>Téléphone :</strong>{" "}
                <a
                  href="tel:+33652794562"
                  className="text-flowkraft-primary hover:underline"
                >
                  +33 (0)6 52 79 45 62
                </a>
              </p>
              <p>
                <strong>Directeur de la publication :</strong> FlowKraft Agency
              </p>
            </div>
          </div>

          {/* Hébergement */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              2. Hébergement
            </h2>
            <div className="text-gray-700 space-y-2">
              <p>
                <strong>Hébergeur :</strong> LWS
              </p>
              <p>
                <strong>Site web :</strong>{" "}
                <a
                  href="https://www.lws.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-flowkraft-primary hover:underline"
                >
                  https://www.lws.fr
                </a>
              </p>
            </div>
          </div>

          {/* Propriété intellectuelle */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              3. Propriété intellectuelle
            </h2>
            <p className="text-gray-700 mb-4">
              L'ensemble de ce site relève de la législation française et
              internationale sur le droit d'auteur et la propriété
              intellectuelle. Tous les droits de reproduction sont réservés, y
              compris pour les documents téléchargeables et les représentations
              iconographiques et photographiques.
            </p>
            <p className="text-gray-700">
              La reproduction de tout ou partie de ce site sur un support
              électronique quel qu'il soit est formellement interdite sauf
              autorisation expresse du directeur de la publication.
            </p>
          </div>

          {/* Protection des données */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              4. Protection des données personnelles
            </h2>
            <p className="text-gray-700 mb-4">
              Conformément à la loi "Informatique et Libertés" du 6 janvier 1978
              modifiée et au Règlement Général sur la Protection des Données
              (RGPD), vous disposez d'un droit d'accès, de rectification, de
              suppression et d'opposition aux données personnelles vous
              concernant.
            </p>
            <p className="text-gray-700">
              Pour exercer ces droits, vous pouvez nous contacter à l'adresse :
              <a
                href="mailto:info@flowkraftagency.com"
                className="text-flowkraft-primary hover:underline ml-1"
              >
                info@flowkraftagency.com
              </a>
            </p>
            <p className="text-gray-700 mt-4">
              Pour plus d'informations, consultez notre{" "}
              <Link
                to="/politique-confidentialite"
                className="text-flowkraft-primary hover:underline"
              >
                Politique de confidentialité
              </Link>
              .
            </p>
          </div>

          {/* Cookies */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              5. Cookies
            </h2>
            <p className="text-gray-700 mb-4">
              Ce site peut utiliser des cookies pour améliorer l'expérience
              utilisateur. Les cookies sont de petits fichiers texte stockés sur
              votre ordinateur par votre navigateur web.
            </p>
            <p className="text-gray-700">
              Vous pouvez configurer votre navigateur pour refuser les cookies.
              Cependant, cela peut affecter certaines fonctionnalités du site.
            </p>
          </div>

          {/* Liens hypertextes */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              6. Liens hypertextes
            </h2>
            <p className="text-gray-700 mb-4">
              Les liens hypertextes mis en place dans le cadre du présent site
              internet en direction d'autres ressources présentes sur le réseau
              Internet ne sauraient engager la responsabilité de FlowKraft
              Agency.
            </p>
          </div>

          {/* Limitation de responsabilité */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              7. Limitation de responsabilité
            </h2>
            <p className="text-gray-700 mb-4">
              FlowKraft Agency ne pourra être tenue responsable des dommages
              directs et indirects causés au matériel de l'utilisateur, lors de
              l'accès au site, et résultant soit de l'utilisation d'un matériel
              ne répondant pas aux spécifications indiquées, soit de
              l'apparition d'un bug ou d'une incompatibilité.
            </p>
            <p className="text-gray-700">
              FlowKraft Agency ne pourra également être tenue responsable des
              dommages indirects consécutifs à l'utilisation du site.
            </p>
          </div>

          {/* Droit applicable */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              8. Droit applicable
            </h2>
            <p className="text-gray-700">
              Les présentes mentions légales sont régies par le droit français.
              En cas de litige et à défaut d'accord amiable, le litige sera
              porté devant les tribunaux français conformément aux règles de
              compétence en vigueur.
            </p>
          </div>

          {/* Date de mise à jour */}
          <div className="text-gray-600 text-sm italic">
            <p>
              Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-20 overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url(/images/main/2149755776.jpg)" }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-flowkraft-primary to-black opacity-90"></div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Des questions ?
          </h2>
          <p className="text-xl mb-8 text-gray-200">
            N'hésitez pas à nous contacter pour toute information complémentaire
          </p>
          <Link
            to="/#contact"
            className="inline-block bg-white text-flowkraft-primary px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Nous contacter
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MentionsLegales;
